<template>
  <v-app>
    <v-container>
      <v-layout row wrap>
        <v-flex lg12 md12 sm12 xs12>
          <div class="mb-3 mt-3">
            <h2>Pagos parciales</h2>
          </div>
          <div>
            <span
              ><router-link
                :to="{ path: '/mis-eventos' }"
                title="Ver todos mis eventos"
                ><u>Volver a Mis Eventos</u></router-link
              ></span
            ><span> > </span><span>Pagos parciales</span>
          </div>
          <div class="mt-3 mb-4"></div>
        </v-flex>
      </v-layout>
      <v-divider></v-divider>  
      <h2>Detalle del Cliente</h2>  
      {{ venta_pago_parcial }}    
      <h2>Detalle de la Venta</h2>    
    </v-container>
  </v-app>
</template>
<script>
import moment from "moment";
moment.locale("es");

import axios from 'axios';
import { configApi } from '../../api/configApi';
import { headers } from '../../api/headers';

export default {
  data() {
    return {
      venta_pago_parcial: [],
      loading: false,
    };
  },
  async beforeCreate() {
    document.title = "Pagos parciales - TicketShop";
    setTimeout(function () {
      self.show_select = true;
    }, 250);
  },
  computed: {
    tipoIdentificaciones() {
      return this.$store.getters["user/listTipoIdentificaciones"];
    },
  },
  mounted() {
    this.buscarVentasPagosParciales()
  },  
  methods: {    
    formatoMoneda(valor) {
      if (valor != null && valor != "") {
        return new Intl.NumberFormat("es-CO").format(valor);
      } else {
        return "";
      }
    },
    formatFechaHumans(fecha) {
      return moment(fecha).fromNow();
    },
    async buscarVentasPagosParciales() {      
     
      await axios.get(`${configApi.apiUrl}detalle_venta_pago_parcial/`+this.$route.params.id_venta, this.data_busqueda, { headers: headers })
      .then(response => {          
        
        this.venta_pago_parcial = response.data.data;
        
      })

    },
    searchFactura(id) {
      this.$store.dispatch("carrito/searchFactura", id);
    },
    limpiarUser() {
      this.$store.dispatch("carrito/limpiarUserSale", false);
    },
    abonarVenta(id) {
      this.abonar_venta = false;
      this.venta = null;
      this.formaPago = "efectivo";
      this.abonar_venta = true;
      this.montoAbonoPagoParcial = 0;
      this.venta = this.pagosParciales.filter((item) => item.id == id)[0];
      //$("html, body").animate({ scrollTop: 700 }, 1000);
    },
    getTotalVenta(detalle_vents, abonado) {
      var totalVenta = 0;
      for (var i = 0; i < detalle_vents.length; i++) {
        totalVenta +=
          detalle_vents[i].precio_servicio +
          detalle_vents[i].precio_venta +
          (detalle_vents[i].precio_servicio + detalle_vents[i].precio_venta) *
            detalle_vents[i].impuesto;
      }
      return totalVenta - abonado;
    },
    changeFormaPago() {
      if (this.formaPago == "mixto") {
        this.montoTarjeta =
          this.getTotalVenta(
            this.venta.detalle_vents,
            this.getTotalAbonado(this.venta.id)
          ) / 2;
        this.montoEfectivo =
          this.getTotalVenta(
            this.venta.detalle_vents,
            this.getTotalAbonado(this.venta.id)
          ) / 2;
      }
    },
    validateSumaPagoMixto() {
      var self = this;
      setTimeout(function () {
        if (
          self.montoEfectivo + self.montoTarjeta >
          self.getTotalVenta(
            this.venta.detalle_vents,
            self.getTotalAbonado(this.venta.id)
          )
        ) {
          self.montoTarjeta =
            self.getTotalVenta(
              this.venta.detalle_vents,
              self.getTotalAbonado(this.venta.id)
            ) / 2;
          self.montoEfectivo =
            self.getTotalVenta(
              this.venta.detalle_vents,
              self.getTotalAbonado(this.venta.id)
            ) / 2;
        }
      }, 1);
    },

    validateMontoPagoParcial() {
      var self = this;
      setTimeout(function () {
        if (
          self.montoAbonoPagoParcial >
          self.getTotalVenta(
            self.venta.detalle_vents,
            self.getTotalAbonado(self.venta.id)
          )
        ) {
          self.montoAbonoPagoParcial = 0;
        }
      }, 1);
    },
    getTotalAbonado(id) {
      var abonos = this.pagosParciales.filter((item) => item.id == id)[0];
      var totalAbonado = abonos.total;

      for (var i = 0; i < abonos.abonos_venta_parcial.length; i++) {
        totalAbonado +=
          abonos.abonos_venta_parcial[i].monto_efectivo +
          abonos.abonos_venta_parcial[i].monto_tarjeta;
      }
      return totalAbonado;
    },
    updateVenta() {
      var self = this;
      swal({
        title: "¿Esta seguro de confirmar el abono a la venta?",
        text: "",
        icon: "warning",
        buttons: ["No, cancelar", "Confirmar"],
        closeModal: true,
      }).then((willDelete) => {
        if (willDelete) {
          self.$store
            .dispatch("carrito/updateVentaPagoParcial", {
              venta_id: self.venta.id,
              monto_abono_pago_parcial: self.montoAbonoPagoParcial,
              datosPago: {
                formaPago: self.formaPago,
                formaPagoTarjeta: self.formaPagoTarjeta,
                montoTarjeta: self.montoTarjeta,
                montoEfectivo: self.montoEfectivo,
                codeVoucher: self.codeVoucher,
              },
            })
            .then(() => {
              self.limpiarUser();
              self.montoAbonoPagoParcial = 0;
              self.codeVoucher = null;
              self.abonar_venta = false;
              self.venta = null;
              self.formaPago = "efectivo";
              self.abonar_venta = false;
              self.montoAbonoPagoParcial = 0;
              $("html, body").animate({ scrollTop: 0 }, 1000);
            });
        }
      });
    },
  },
};
</script>
<style>
.elevation-1.table-ventas table thead {
  background-color: #cacaca;
}
.elevation-1.table-ventas table thead th {
  color: black;
  font-weight: bold;
}
.elevation-1.table-ventas table tbody td {
  color: black;
  font-size: 16px;
}
</style>